export default __webpack_public_path__ + "static/media/dongho_big.097bec46.png";